module.exports = __webpack_public_path__ + "assets/img/13_984_big.f036503e.jpg";